import { render } from "./TaskResult.vue?vue&type=template&id=115ac224"
import script from "./TaskResult.vue?vue&type=script&lang=js"
export * from "./TaskResult.vue?vue&type=script&lang=js"

import "./TaskResult.vue?vue&type=style&index=0&id=115ac224&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__